import { createFileRoute } from '@tanstack/react-router';
import { CriteriaTab } from '@/components/health-readiness/criteria-tab';

/** Health & Readiness → Go-live criteria, one criterion open (T-0242). */
export const Route = createFileRoute(
  '/engagements/$engagementId/health-readiness/criteria/$criterionId',
)({
  component: CriterionRoute,
});

function CriterionRoute() {
  const { engagementId, criterionId } = Route.useParams();
  return <CriteriaTab engagementId={engagementId} criterionId={criterionId} />;
}
